<div>
    <hub-modal-header headerText="{{ 'bikeshop.modal.shedule_service.group_all_active_jobs' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="row">
        <div class="col-lg-12">
            <div class="message" innerHTML="{{ 'bikeshop.modal.shedule_service.group_all_active_jobs_message' | translate }}"></div>
        </div>
    </div>
    
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'bikeshop.modal.shedule_service.leave_jobs_ungrouped' | translate"
            [style]="'outline'" (buttonClick)="cancel()"
            [size]="'xl'"></hub-button>
        <hub-button [text]="'bikeshop.modal.shedule_service.group_jobs' | translate"
            [style]="'secondary'" (buttonClick)="groupJobs()"
            [size]="'xl'"></hub-button>
    </div>
</div>